import {Component, OnInit} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ConfiguratorEtlService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-etl-update',
    templateUrl: './etl-update.component.html',
    providers: [MessageService],
    standalone: false
})
export class EtlUpdateComponent implements OnInit {
    breadcrumb: MenuItem[];
    description = '';

    /** Nom de l'import déjà enregistré, affiché dans le titre : c'est ce qui distingue une
     *  configuration d'une création, et qui dit de quel import il s'agit. */
    name: string = null;

    datastore: string = null;
    partner: string = null;

    items: MenuItem[];
    activeIndex = 0;
    id: string = null;

    complet: boolean;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly translate: TranslateService,
        private readonly configuratorEtlService: ConfiguratorEtlService
    ) {
    }

    ngOnInit() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const me = this;
        this.id = this.route.snapshot.paramMap.get('id');
        this.datastore = this.route.snapshot.paramMap.get('tenant');
        this.partner = this.route.snapshot.queryParamMap.get('partner');
        const step = parseInt(this.route.snapshot.paramMap.get('step'));
        this.updateBreadcrumb();
        if (this.id) {
            this.configuratorEtlService.getSetupUsingGET(this.datastore, this.id).subscribe(setup => {
                this.name = setup?.name ?? null;
                this.updateBreadcrumb();
            });
        }
        this.items = [
            {
                label: this.translate.instant('etl.new.steps.source'),
                command: (event: any) => {
                    if (this.activeIndex < 0 && !this.complet) {
                        me.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '0']);
                    }
                },
                disabled: false
            },
            {
                label: this.translate.instant('etl.new.steps.mapping'),
                command: (event: any) => {
                    if (this.activeIndex < 1 && !this.complet) {
                        if (this.partner) {
                            me.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '1'], { queryParams: { partner: this.partner } });
                        } else {
                            me.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '1']);
                        }
                    }
                },
                disabled: false
            },
            {
                label: this.translate.instant('etl.new.steps.filter'),
                command: (event: any) => {
                    if (this.activeIndex < 2 && !this.complet) {
                        me.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '2']);
                    }
                },
                disabled: false
            },
            {
                label: this.translate.instant('etl.new.steps.schedule'),
                command: (event: any) => {
                    if (this.activeIndex < 3 && !this.complet) {
                        me.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '3']);
                    }
                },
                disabled: false
            }
        ];
        this.goToStep(step);
    }

    /** Dernier segment du fil d'Ariane : « Nouvel import », ou le nom de l'import configuré. */
    private updateBreadcrumb() {
        this.breadcrumb = [
            {label: this.translate.instant('menu.flow.label')},
            {label: this.translate.instant('menu.flow.imports'), routerLink: '/h/flux/import-v1/etl'},
            {label: this.id ? (this.name ?? this.translate.instant('etl.new.title-configure')) : this.translate.instant('etl.new.title-new')}];
    }

    public goToStep(index = 0) {
        if (this.id) {
            this.activeIndex = index;
        }
    }

    setpSetup(id: string) {
        this.activeIndex = 0;
    }

    stepDesign(event: { uuid: string; tenant?: string; partner?: string; name?: string; }) {
        if (event.uuid) {
            this.id = event.uuid;
        }
        // Le nom vient d'être enregistré à l'étape Source : le composant est réutilisé d'une étape à
        // l'autre (même route), le titre ne serait sinon pas mis à jour.
        if (event.name) {
            this.name = event.name;
            this.updateBreadcrumb();
        }
        if (event.tenant) {
            this.datastore = event.tenant;
        }
        if (event.partner){
            this.partner = event.partner;
        }
        if(this.partner){
            this.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '1'], { queryParams: { partner: this.partner } });
        } else {
            this.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '1']);
        }
        this.activeIndex = 1;
    }

    stepFilter(event: { uuid: string; tenant?: string }) {
        this.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '2']);
        this.activeIndex = 2;
    }

    stepProcess(event: { uuid: string; tenant?: string }) {
        this.router.navigate(['/h/flux/import-v1/etl', this.datastore, this.id, '3']);
        this.activeIndex = 3;
    }

    listEtl($event: string) {
        this.router.navigate(['/h/flux/import-v1/etl']);
    }
}
